import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import { BrowserRouter } from "react-router-dom";

import { EnrutadorApp } from "./app/router";
import { ProveedorSesion } from "./app/SesionContext";
import { ProveedorToast } from "./ui/Toast";

/**
 * Shell definitivo (F06): design system, sesión + finca activa, router.
 * El placeholder de F01 queda reemplazado por completo acá.
 */
export default function App() {
  const [clienteConsultas] = useState(() => new QueryClient());

  return (
    <QueryClientProvider client={clienteConsultas}>
      <ProveedorToast>
        <BrowserRouter>
          <ProveedorSesion>
            <EnrutadorApp />
          </ProveedorSesion>
        </BrowserRouter>
      </ProveedorToast>
    </QueryClientProvider>
  );
}
